export const H3 = {
  fontSize: {
    xs: '22px',
    sm: '24px',
    md: '26px',
    lg: '28px',
    xl: '30px'
  },
  lineHeight: {
    xs: '30px',
    sm: '32px',
    md: '34px',
    lg: '36px',
    xl: '40px'
  }
};